module.exports = __webpack_public_path__ + "img/11招商加盟-img1_03.f9ba32d1.png";